import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./routes/ProtectedRoute";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import AdminDashboardLayout from "./layout/AdminDashboardLayout";
import Home from "./pages/Home";
import Mailboxes from "./pages/Mailboxes";
import Tenants from "./pages/Tenants";
import Tickets from "./pages/Tickets";
import Settings from "./pages/Settings";
import Trash from "./pages/Trash";
import NotFoundPage from "./pages/NotFoundPage";
import UnauthorizedPage from "./pages/UnauthorizedPage";

export default function App() {
  return (
    //Wrap the app in the AuthProvider to provide authentication context to all components
    <AuthProvider>
      {/* Look at the URL and render the appropriate page/component based on the route */}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          
          {/*<Route path="/register" element={<RegisterPage />} /> TODO: Implement the registration page */}
          {/*<Route path="/contact" element={<ContactPage />} /> TODO: Implement the contact page */}
          {/*<Route path="/about" element={<AboutPage />} /> TODO: Implement the about page */}
          {/*<Route path="/faq" element={<FAQPage />} /> TODO: Implement the FAQ page */}  
          {/*<Route path="/forgot-password" element={<ForgotPasswordPage />} /> TODO: Implement the forgot password page */}
          {/*<Route path="/forgot-username" element={<ForgotUsernamePage />} /> TODO: Implement the forgot username page */}

          {/* Protected dashboard */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminDashboardLayout />
              </ProtectedRoute>
            }
          >
            {/* nested pages inside the admin dashboard */}
            <Route index element={<Home />} />
            <Route path="mailboxes" element={<Mailboxes />} />
            <Route path="tenants" element={<Tenants />} />
            <Route path="tickets" element={<Tickets />} />
            <Route path="settings" element={<Settings />} />
            <Route path="trash" element={<Trash />} />
          </Route>

          <Route path="/unauthorized" element={<UnauthorizedPage />} />
          <Route path="*" element={<NotFoundPage />} /> {/* catch-all non existing routes and show 404 Not Found */}
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
